class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById('cart-notification');
    this.header = document.querySelector('sticky-header');
    this.onBodyClick = this.handleBodyClick.bind(this);

    this.notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
      closeButton.addEventListener('click', this.close.bind(this))
    );

    this.notification.addEventListener('click', this.handleQuantityClick.bind(this));
    this.parseState = {};
  }

  open() {
    this.notification.classList.add('animate', 'active');

    this.notification.addEventListener(
      'transitionend',
      () => {
        this.notification.focus();
        // eslint-disable-next-line no-undef
        trapFocus(this.notification);
      },
      { once: true }
    );

    document.body.addEventListener('click', this.onBodyClick);

    this.updateMinusButtonState();
  }

  close() {
    this.notification.classList.remove('active');
    document.body.removeEventListener('click', this.onBodyClick);

    // eslint-disable-next-line no-undef
    removeTrapFocus(this.activeElement);
  }

  renderContents(parsedState) {
    this.parseState = parsedState;
    this.cartItemKey = parsedState.key;
    this.getSectionsToRender().forEach((section) => {
      document.getElementById(section.id).innerHTML = this.getSectionInnerHTML(
        parsedState.sections[section.id],
        section.selector
      );
    });

    if (this.header) this.header.reveal();
    this.open();
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-notification-product',
        selector: `[id="cart-notification-product-${this.cartItemKey}"]`,
      },
      {
        id: 'cart-notification-button',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  // eslint-disable-next-line class-methods-use-this
  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  handleBodyClick(evt) {
    const {target} = evt;
    if (target !== this.notification && !target.closest('cart-notification')) {
      const disclosure = target.closest('details-disclosure, header-menu');
      this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }

  // eslint-disable-next-line class-methods-use-this
  async fetchCartData() {
    const response = await fetch('/cart.json');
    if (!response.ok) {
      throw new Error(`Network response was not ok ${  response.statusText}`);
    }
    const data = await response.json();
    return data;
  }

  handleQuantityClick(evt) {
    const {target} = evt;
    if (target.matches('.plus-icon') || target.matches('.icon-minus')) {
      const quantityInput = target.closest('.quantity');
      const input = quantityInput.querySelector('.quantity__input');
      // const change = target.matches('.plus-icon') ? 1 : -1;

      let newQuantity = parseInt(input.value, 10);
      newQuantity = newQuantity < 1 ? 1 : newQuantity; // Prevent quantity from going below 1
      input.value = newQuantity;
      this.updateCartQuantity(input.id, newQuantity, target);
      const qtyBox = document.querySelector('.quantity-container .quantity');
      qtyBox.style.pointerEvents = 'none';
    }

    if (target.matches('.cart-remove-button-notification') || target.matches('.icon-remove')) {
      const buttonElement = document.querySelector('.cart-remove-button-notification');

      // Get the value of the data-variant-id attribute
      const variantId = buttonElement.getAttribute('data-variant-id');
      this.removeCartItem(variantId);
    }
  }

  async removeCartItem(variantId) {
    const updates = {};
    updates[variantId] = 0;

    try {
      const response = await fetch('/cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ updates })
      });

      if (!response.ok) {
        throw new Error(`Network response was not ok ${  response.statusText}`);
      }

      const data = await response.json();
      if (data) {
        const cartData = await this.fetchCartData();
        const cartItemCount = cartData.item_count;

        const cartCountSpan = document.querySelector('.cart-count-bubble');
        const cartNotificationButton = document.querySelector('#cart-notification-button');
        cartCountSpan.innerHTML = `<span aria-hidden="true">&nbsp;(${cartItemCount})</span><span class="visually-hidden">&nbsp;${cartItemCount} items</span>`;
        cartNotificationButton.innerHTML = `View cart (${cartItemCount})`;
        this.close();
      }
    } catch (error) {
      console.error('Failed to update cart quantity:', error);
    }
  }

  async updateCartQuantity(variantId, quantity, target) {
    const updates = {};
    const variantItemId = variantId.replace('Quantity-', '')
    updates[variantItemId] = quantity;

    try {
      const response = await fetch('/cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ updates })
      });

      if (!response.ok) {
        throw new Error(`Network response was not ok ${  response.statusText}`);
      }

      const data = await response.json();
      if (data) {
        const cartData = await this.fetchCartData();
        const cartItem = cartData.items.find(item => item.id === parseInt(variantItemId, 10));

        if (cartItem) {
          const itemPrice = cartItem.original_line_price;
          const cartItemCount = cartData.item_count;
          const Currency = cartData.currency;

          const cartCountSpan = document.querySelector('.cart-count-bubble');
          const cartNotificationButton = document.querySelector('#cart-notification-button');
          cartCountSpan.innerHTML = `<span aria-hidden="true">&nbsp;(${cartItemCount})</span><span class="visually-hidden">&nbsp;${cartItemCount} items</span>`;
          cartNotificationButton.innerHTML = `View cart (${cartItemCount})`;
          document.querySelector('.cart-notification-product__info-subtotal .product-item-price').innerHTML = this.formatPrice(itemPrice, Currency);

          const notificationMsgElement = document.querySelector('.item_notification_msg');
          if (target.matches('.plus-icon')) {
            notificationMsgElement.innerHTML = '1 Item added to bag';
          } else {
            notificationMsgElement.innerHTML = '1 Item removed from bag';
          }

          const qtyBoxUpdated = document.querySelector('.quantity-container .quantity');
          qtyBoxUpdated.style.pointerEvents = 'auto';
          this.updateMinusButtonState();
        } else {
          console.warn(`Cart item with ID ${variantItemId} not found`);
        }
      }
    } catch (error) {
      console.error('Failed to update cart quantity:', error);
    }
  }

  updateMinusButtonState() {
    const quantityInput = this.notification.querySelector('.quantity__input');
    const minusButton = this.notification.querySelector('.icon-minus');
    if (quantityInput && minusButton) {
      const quantity = parseInt(quantityInput.value, 10);
      minusButton.disabled = quantity <= 1;
    }
  }

  // eslint-disable-next-line class-methods-use-this
  formatPrice(price, currency) {
    return new Intl.NumberFormat('en-US', { style: 'currency', currency }).format(price / 100);
  }
}

customElements.define('cart-notification', CartNotification);
